<template>
  <main id="page-wrap">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12">
          <div class="breadcrumb-wrap">
            <a href="" @click.prevent="gotoAd">Min annons</a> / <span class="current">Bilder</span>
          </div>
        </div>

        <!-- Main conten inside here -->
        <div class="cell small-12 medium-4 show-for-medium">
          <div sticky-container class="sticky-container">
            <div
              v-sticky
              sticky-offset="offset"
              sticky-side="top"
              class="sticky-inner">
              <aside class="sidebar-wrap">
                <div class="sidebar-content">
                  <!-- <button class="button" @click.prevent="gotoAd">
                    Tillbaks till annonsen
                  </button> -->

                  <section class="highlight-box">
                    <header>
                      <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56"><path fill-rule="evenodd" d="M27.130246 30.460861l6.44827-6.44827c.644365-.644365 1.689088-.644365 2.333453 0l.053033.053033c.644365.644365.644365 1.689087 0 2.333452l-7.566043 7.566043c-.004106.004106-.008228.008186-.012367.012239-.00401.004095-.008047.008175-.01211.012237-.630846.630847-1.653651.630847-2.284498 0l-4.079463-4.079462c-.630847-.630847-.630847-1.653652 0-2.284499.630847-.630847 1.653652-.630847 2.284499 0l2.835226 2.835227zm29.36962-2.460811c0 1.895828-.492186 3.682284-1.476558 5.359362-.984373 1.677079-2.3151 2.989576-3.992178 3.937491.510416 1.895828.528644 3.773428.054687 5.632799-.473957 1.859371-1.403642 3.481762-2.789056 4.867176s-3.007805 2.315099-4.867176 2.789056c-1.85937.473956-3.700511.455728-5.523424-.054688-1.020831 1.677079-2.369787 3.007806-4.046866 3.992178-1.677078.984373-3.463534 1.476559-5.359362 1.476559-1.895828 0-3.682283-.492186-5.359362-1.476559-1.677079-.984372-2.989576-2.315099-3.937491-3.992178-1.822912.510416-3.682283.528644-5.578111.054688-1.895829-.473957-3.53645-1.403642-4.921864-2.789056-1.385413-1.385414-2.315099-3.007805-2.789055-4.867176-.473957-1.859371-.455729-3.736971.054687-5.632799-1.677079-.947915-3.007805-2.260412-3.992178-3.937491C.992186 31.682334.5 29.895878.5 28.00005c0-1.895828.492186-3.682283 1.476559-5.359362.984373-1.677079 2.315099-3.026035 3.992178-4.046866-.510416-1.822912-.528644-3.664053-.054687-5.523424.473956-1.85937 1.403642-3.481762 2.789055-4.867176 1.385414-1.385414 3.007806-2.315099 4.867176-2.789056 1.859371-.473956 3.736971-.455728 5.632799.054688.947915-1.677079 2.260412-3.007806 3.937491-3.992178C24.81765.492303 26.604105.000117 28.499933.000117c1.895828 0 3.682284.492186 5.359362 1.476559 1.677079.984372 3.026035 2.315099 4.046866 3.992178 1.822913-.510416 3.664054-.528644 5.523424-.054688 1.859371.473957 3.481762 1.403642 4.867176 2.789056s2.315099 3.007806 2.789056 4.867176c.473957 1.859371.455729 3.736971-.054687 5.632799 1.677078.947915 3.007805 2.260412 3.992178 3.937491.984372 1.677079 1.476558 3.463534 1.476558 5.359362zm-9.953101 7.437482l.328124-.109374c4.083323-1.385414 6.124986-3.828116 6.124986-7.328108 0-2.260412-.802081-4.046865-2.406244-5.359362-.874998-.729166-2.114578-1.385414-3.718742-1.968745l-.328124-.109375.109375-.328124c1.968745-3.864574 1.677079-7.036441-.874998-9.515603-1.531246-1.604163-3.354159-2.333327-5.468737-2.187495-1.166664.145833-2.515619.583332-4.046865 1.312497l-.328124.109375-.109375-.328124c-1.385414-4.083323-3.828116-6.124986-7.328108-6.124986-2.260412 0-4.046865.802081-5.359362 2.406245-.729165.874998-1.385414 2.114577-1.968745 3.718741l-.109375.328124-.328124-.109375c-3.864574-1.895828-7.036441-1.604163-9.515603.874998C9.614561 12.250088 8.885397 14.073 9.03123 16.187578c.145832 1.166665.583331 2.515619 1.312497 4.046866l.109374.328124-.328124.109375c-4.083323 1.385413-6.124985 3.828115-6.124985 7.328107 0 2.260412.802081 4.046865 2.406244 5.359362.874998.729166 2.114578 1.385414 3.718741 1.968746l.328124.109374-.109374.328125c-1.968746 3.864573-1.677079 7.036441.874997 9.515602 1.385414 1.458329 2.953118 2.187495 4.703114 2.187495 1.312497 0 3.026035-.473957 5.140613-1.421872l.109375.328124c1.385414 4.083323 3.828116 6.124986 7.328107 6.124986 2.260412 0 4.046866-.802081 5.359362-2.406245.729166-.874998 1.385414-2.114577 1.968746-3.718741l.109375-.328124c2.114577.947915 3.828115 1.421872 5.140612 1.421872 1.749996 0 3.3177-.729166 4.703114-2.187495 1.604163-1.531246 2.333327-3.354159 2.187495-5.468737-.145833-1.166665-.583332-2.515619-1.312497-4.046865-.072917-.145833-.109375-.255208-.109375-.328125z" /></svg>
                      <h2>Fototips!</h2>
                      <p>En annons med bilder får många fler bytesförslag än dom utan</p>
                    </header>
                  </section>

                  <section class="todo-box">
                    <ul>
                      <li>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><path fill="#64BCB2" fill-rule="nonzero" d="M12.5 25C5.59644063 25 0 19.4035594 0 12.5 0 5.59644063 5.59644063 0 12.5 0 19.4035594 0 25 5.59644063 25 12.5 25 19.4035594 19.4035594 25 12.5 25zm0-3c5.2467051 0 9.5-4.2532949 9.5-9.5C22 7.25329488 17.7467051 3 12.5 3 7.25329488 3 3 7.25329488 3 12.5c0 5.2467051 4.25329488 9.5 9.5 9.5zm-1.2573593-8.9289322l3.8890873-3.88908728c.5857864-.58578644 1.5355339-.58578644 2.1213203 0 .5857865.58578643.5857865 1.53553388 0 2.12132038l-4.9497474 4.9497474c-.5857865.5857865-1.5355339.5857865-2.1213204 0L8.06066017 14.131728c-.58578644-.5857865-.58578644-1.5355339 0-2.1213204.58578644-.5857864 1.53553391-.5857864 2.12132033 0l1.0606602 1.0606602z" /></svg>
                        <span>Tänd alla lampor, släpp in naturligt&nbsp;ljus</span>
                      </li>
                      <li>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><path fill="#64BCB2" fill-rule="nonzero" d="M12.5 25C5.59644063 25 0 19.4035594 0 12.5 0 5.59644063 5.59644063 0 12.5 0 19.4035594 0 25 5.59644063 25 12.5 25 19.4035594 19.4035594 25 12.5 25zm0-3c5.2467051 0 9.5-4.2532949 9.5-9.5C22 7.25329488 17.7467051 3 12.5 3 7.25329488 3 3 7.25329488 3 12.5c0 5.2467051 4.25329488 9.5 9.5 9.5zm-1.2573593-8.9289322l3.8890873-3.88908728c.5857864-.58578644 1.5355339-.58578644 2.1213203 0 .5857865.58578643.5857865 1.53553388 0 2.12132038l-4.9497474 4.9497474c-.5857865.5857865-1.5355339.5857865-2.1213204 0L8.06066017 14.131728c-.58578644-.5857865-.58578644-1.5355339 0-2.1213204.58578644-.5857864 1.53553391-.5857864 2.12132033 0l1.0606602 1.0606602z" /></svg>
                        <span>Städa undan för ett renare &amp; bättre&nbsp;intryck</span>
                      </li>
                      <li>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><path fill="#64BCB2" fill-rule="nonzero" d="M12.5 25C5.59644063 25 0 19.4035594 0 12.5 0 5.59644063 5.59644063 0 12.5 0 19.4035594 0 25 5.59644063 25 12.5 25 19.4035594 19.4035594 25 12.5 25zm0-3c5.2467051 0 9.5-4.2532949 9.5-9.5C22 7.25329488 17.7467051 3 12.5 3 7.25329488 3 3 7.25329488 3 12.5c0 5.2467051 4.25329488 9.5 9.5 9.5zm-1.2573593-8.9289322l3.8890873-3.88908728c.5857864-.58578644 1.5355339-.58578644 2.1213203 0 .5857865.58578643.5857865 1.53553388 0 2.12132038l-4.9497474 4.9497474c-.5857865.5857865-1.5355339.5857865-2.1213204 0L8.06066017 14.131728c-.58578644-.5857865-.58578644-1.5355339 0-2.1213204.58578644-.5857864 1.53553391-.5857864 2.12132033 0l1.0606602 1.0606602z" /></svg>
                        <span>Plocka bort personliga&nbsp;föremål</span>
                      </li>
                      <li>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><path fill="#64BCB2" fill-rule="nonzero" d="M12.5 25C5.59644063 25 0 19.4035594 0 12.5 0 5.59644063 5.59644063 0 12.5 0 19.4035594 0 25 5.59644063 25 12.5 25 19.4035594 19.4035594 25 12.5 25zm0-3c5.2467051 0 9.5-4.2532949 9.5-9.5C22 7.25329488 17.7467051 3 12.5 3 7.25329488 3 3 7.25329488 3 12.5c0 5.2467051 4.25329488 9.5 9.5 9.5zm-1.2573593-8.9289322l3.8890873-3.88908728c.5857864-.58578644 1.5355339-.58578644 2.1213203 0 .5857865.58578643.5857865 1.53553388 0 2.12132038l-4.9497474 4.9497474c-.5857865.5857865-1.5355339.5857865-2.1213204 0L8.06066017 14.131728c-.58578644-.5857865-.58578644-1.5355339 0-2.1213204.58578644-.5857864 1.53553391-.5857864 2.12132033 0l1.0606602 1.0606602z" /></svg>
                        <span>Använd en liggande bild för&nbsp;annonsbilden</span>
                      </li>
                    </ul>
                  </section>
                </div>
              </aside>
            </div>
          </div>
        </div>

        <div class="cell small-12 medium-8">
          <section id="ad-photos">
            <div class="page-divider">
              <div class="grid-x grid-margin-x">
                <div class="cell small-12 medium-6">
                  <router-link :to="{ name: 'adlist' }" class="button button-large secondary" style="margin:0px 0px 20px 0px !important;text-align:center;marker:pointer;text-decoration: none;">
                    Hitta byte
                  </router-link>
                </div><div class="cell small-12 medium-6">
                  <router-link :to="{ name: 'ad', params: { id: adid } }" class="button button-large secondary" style="margin:0px 0px 20px 0px !important;text-align:center;marker:pointer;text-decoration: none;">
                    Visa min annons
                  </router-link>
                </div>
              </div>
              <h2>Dina bilder</h2>
              <!-- If the flat has exactly one photo -->
              <template v-if="photos.length == 1">
                <p><strong>En bild är en bra början</strong>, men annnonser med fler än 5 bilder får betydligt mycket mer matchningar.</p>
              </template>

              <!-- If the flat has more than one photo -->
              <template v-if="photos.length > 1">
                <p><strong>Dra och släpp</strong> bilderna i ordningen du vill att dom skall synas i annonsen. Den översta bilden blir din utvalda annonsbild och gör sig bäst i <strong>liggande format</strong>.</p>
              </template>

              <!-- If the flat does not have photos -->
              <template v-if="photos.length == 0">
                <p>En annons med bilder har <strong>mycket större chans</strong> att få en matchning.</p>
              </template>
              <Uploader :id="flatid" @uploaded="uploadHandler" />
            </div>

            <draggable v-model="photos"
                       v-bind="dragOptions"
                       group="photos"
                       class="img-move"
                       handle=".move-handle"
                       @start="drag = true"
                       @end="
                         checkMove()
                         drag = false
                       ">
              <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <div v-for="(photo, index) in photos" :key="photo.id" class="upload-image-item-wrap">
                  <div class="ghost-frame"></div>

                  <PhotoEdit
                    :id="flatid"
                    ref="photo"
                    :photo="photo"
                    :index="index"
                    @delete="deletePhoto(index)"
                    @primary="makePrimary(index)" />
                </div>
              </transition-group>
            </draggable>
          </section>
        </div>
        <!-- Main conten inside here : END -->
      </div>
    </div>
  </main>
</template>

<script>
import AdService from '@/services/AdService.js'
import draggable from 'vuedraggable'
import PhotoEdit from '@/components/PhotoEdit.vue'
import Uploader from '@/components/Uploader.vue'

export default {
  components: {
    draggable,
    PhotoEdit,
    Uploader
  },
  props: {
    flatid: {
      type: String,
      required: true
    },
    adid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      offset: {
        top: 50,
        bottom: 100
      },
      photos: [],
      drag: false
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
    // updatePhotos() {
    //   return ['x']
    //   // return this.photos
    //   // let updatePhotos = this.photos
    //   // return updatePhotos.map(x => {
    //   //   delete x.img_url
    //   //   return { ...x }
    //   // })
    // }
  },
  watch: {
    photos: function () {
      // console.log('nu uppdaterads den')
      // this.$refs.photo[0].updateForm()
      // console.log(this.photos)
      // this.checkMove()
    }
  },
  mounted () {
    AdService.getPhotos(this.flatid)
      .then(result => {
        this.photos = result.data.data.map((photo, index) => {
          return { ...photo, sort_order: index, display: true }
        })
        // this.checkMove()
      })
      .catch(error => {
        // Without the id this pushes to /bostad/ and the catch-all turns it
        // into a 404. Anyone who may not edit these photos (not the owner)
        // gets the listing itself instead.
        this.gotoAd()
        // console.log(error)
      })
  },
  methods: {
    gotoAd () {
      this.$router.push({ name: 'ad', params: { id: this.adid } })
    },
    uploadHandler (photo) {
      // console.log(photo)
      let newPhoto = {
        id: photo.id,
        style: photo.style,
        img_url: photo.url,
        display: true,
        sort_order: this.photos.length,
        room: 0
      }
      this.photos.push(newPhoto)
      this.checkMove()
      this.$nextTick(() => {
        let items = document.querySelectorAll('.upload-image-item-wrap')
        let last = items[items.length - 1]
        if (last) {
          last.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      })
    },
    deletePhoto (index) {

      const photoIDtoDelete = this.photos[index].id;
      // this.$swal('Hello Vue world!!!')
      console.log({photoIDtoDelete, index});

      this.$swal
        .fire({
          title: 'Är du säker?',
          text: 'Om du raderar bilden så försvinner den från din annons',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#ff7660',
          cancelButtonColor: '#61bbb2',
          confirmButtonText: 'Ja, radera bilden!',
          cancelButtonText: 'Avbryt'
        })
        .then(result => {

          console.log({result});
          if (result.value) {

            console.log('Deletig photo with id: ' + photoIDtoDelete)
            this.photos[index].display = false
            // console.log('Delete ' + index);
            
            // console.log('Delete ' + this.photos[index].id)
            AdService.deletePhoto(this.photos[index].id)
              .then(response => {
                // this.awss3 = response.data.data

                const newPhotos = this.photos.filter((photo, i) => {
                  return photo.id !== photoIDtoDelete
                });
                this.photos = newPhotos;
                // this.photos.splice(index, 1)
              })
              .catch(error => {
                // console.log(error)
                this.gotoAd()
              })

            this.$swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            )
          }
        })
    },

    makePrimary (index) {
      // console.log(this.photos[index].id)
    },
    checkMove () {
      // console.log(this.photos)
      //   let photos = this.photos
      this.photos = this.photos.map((photo, index) => {
        return { ...photo, sort_order: index }
      })
      // console.log(this.photos)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/abstracts/_variables.scss';

.sidebar-content{padding-top:54px;}

.wrapper {
  margin-top: 74px;
}


.list-group-item {
  cursor: move;
}
.list-group-item img {
  cursor: pointer;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
// .ghost {
//   opacity: 0.5;
//   background: $color-secondary;
// }
</style>
